import { useState } from "react";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export function useRecurringGuard() {
  const [pending, setPending] = useState(null);
  const guard = async (userIds, proceed) => {
    if (!userIds.length) return proceed(false);
    const { data } = await api.get("/recurrence-conflicts", { params: { user_ids: userIds.join(",") } });
    if (!data.length) return proceed(false);
    setPending({ conflicts: data, proceed });
  };
  const choose = (v) => { const p = pending; setPending(null); p.proceed(v); };
  const dialog = (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
      <AlertDialogContent className="w-[calc(100%-2rem)] rounded-2xl" data-testid="recurring-conflict-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Ha ordini ricorrenti in corso: li sospendo?</AlertDialogTitle>
          <AlertDialogDescription>Se sospendi, la ricorrenza si ferma solo per queste persone fino a quando questo ordine viene completato o annullato, poi riprende da sola.</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2 text-sm">{pending?.conflicts.map((c) => (
          <div key={c.user_id} className="rounded-xl border p-3" data-testid={`recurring-conflict-${c.user_id}`}>
            <p className="font-bold">{c.user_name}</p>
            {c.recurrences.map((r) => <p key={r.id} className="text-xs text-muted-foreground">{r.title} · <span className="capitalize">{r.days_label}</span> · {r.time}</p>)}
          </div>
        ))}</div>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="rounded-xl" data-testid="recurring-conflict-cancel">Annulla</AlertDialogCancel>
          <Button variant="outline" className="rounded-xl" onClick={() => choose(false)} data-testid="recurring-conflict-keep">No, assegna senza sospendere</Button>
          <Button className="rounded-xl font-bold" onClick={() => choose(true)} data-testid="recurring-conflict-suspend">Sì, sospendi</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
  return { guard, dialog };
}
